import { useQuery } from '@tanstack/react-query'
import { useAuthStore } from '@shared/store/authStore'
import { getOrganization } from '@shared/api/organizationApi'

/**
 * Hook to fetch current organization data.
 * Every user always has an organization; selectedOrganizationId is null only during initial load.
 */
export function useCurrentOrganization() {
  const selectedOrganizationId = useAuthStore((state) => state.selectedOrganizationId)

  return useQuery({
    queryKey: ['organization', selectedOrganizationId],
    queryFn: () => getOrganization(selectedOrganizationId as string),
    enabled: !!selectedOrganizationId,
    staleTime: 5 * 60 * 1000, // Cache for 5 minutes
  })
}
